import request from "../../../util/SuperagentUtils";
import { formatDateMMDDyyyy } from "../../../util/DateUtils";
import { supplierSpaceUsageReportEndpoints } from "../../api-endpoints";

const getSpaceUsageQueryParams = (searchParams: {}, isPageable: boolean) => {

  const { page, size, startDate, endDate, locationId, locationName, bookingNumber, overageInvoiceNumber, sortBy, sortDir, groupBy } = searchParams;

  const queryParams = isPageable ? new URLSearchParams([["page", page || 0], ["size", size || 10]]) : new URLSearchParams();

  if (startDate) queryParams.append("startDate", formatDateMMDDyyyy(startDate));
  if (endDate) queryParams.append("endDate", formatDateMMDDyyyy(endDate));
  if (locationId) queryParams.append("locationId", locationId);
  if (locationName) queryParams.append("locationName", locationName);
  if (bookingNumber) queryParams.append("bookingNumber", bookingNumber);
  if (overageInvoiceNumber) queryParams.append("overageInvoiceNumber", overageInvoiceNumber);
  if (sortBy) queryParams.append("sortBy", sortBy);
  if (sortDir) queryParams.append("sortDir", sortDir);
  if (groupBy) queryParams.append("groupBy", groupBy);

  return queryParams;
}

export const getSupplierSpaceUsageByPage:
  (searchParams: {}) =>
    Promise = (searchParams) => {

  return request.get(`${supplierSpaceUsageReportEndpoints.search}?${getSpaceUsageQueryParams(searchParams, true).toString()}`);
};

export const getSupplierSpaceUsageReportUrl = (searchParams) => {
  return `${supplierSpaceUsageReportEndpoints.report}?${getSpaceUsageQueryParams(searchParams, false).toString()}`;
};

export const getSupplierSpaceUsageGroupSummaryReportUrl: (searchParams: {startDate: string; endDate: string; locationId: string; locationName: string, groupBy?: string}) =>
  string = (searchParams) => {
    let summaryParams;

    if(searchParams) {
        summaryParams= {
        startDate: searchParams.startDate,
        endDate: searchParams.endDate,
        locationId: searchParams.locationId,
        locationName: searchParams.locationName,
        groupBy: searchParams.groupBy
      }
    }

  return searchParams ? `${supplierSpaceUsageReportEndpoints.group}?${getSpaceUsageQueryParams(summaryParams, false)}` : "";

};